module.exports = __webpack_public_path__ + "static/media/icon_order.08730d91.svg";